// extracted by mini-css-extract-plugin
module.exports = {"FranchizeButton":"FranchizeButton_FranchizeButton__FeKua"};